export default __webpack_public_path__ + "static/media/kyle.9c8e5180.png";